<div class="blocks-container">
  <div class="block-item" (click)="filterByStatus(null)">
    <div class="block-row-title">{{'' | i18n: 'dash-header-all'}}.</div>
    <div class="block-row-count">{{ getCountForType('all') }}</div>
  </div>
  <div class="block-item" (click)="filterByStatus('Accepted')">
    <div class="block-row-title">{{'' | i18n: 'dash-header-accept'}}.</div>
    <div class="block-row-count">{{getCountForType('Accepted')}}</div>
  </div>
  <div class="block-item" (click)="filterByStatus('Active')">
    <div class="block-row-title">{{'' | i18n: 'dash-header-active'}}.</div>
    <div class="block-row-count">{{getCountForType('Active')}}</div>
  </div>
  <div class="block-item" (click)="filterByStatus('In Progress')">
    <div class="block-row-title">{{'' | i18n: 'dash-header-in-progress'}}.</div>
    <div class="block-row-count">{{getCountForType('In Progress')}}</div>
  </div>
  <div class="block-item" (click)="filterByStatus('In Dealer Correction')">
    <div class="block-row-title">{{'' | i18n: 'dash-header-in-dealer-correction'}}.</div>
    <div class="block-row-count">{{getCountForType('In Dealer Correction')}}</div>
  </div>
  <div class="block-item" (click)="filterByStatus('In Review')">
    <div class="block-row-title">{{'' | i18n: 'dash-header-in-review'}}.</div>
    <div class="block-row-count">{{getCountForType('In Review')}}</div>
  </div>
  <div class="block-item" (click)="filterByStatus('Cancelled')">
    <div class="block-row-title">{{'' | i18n: 'dash-header-cancelled'}}.</div>
    <div class="block-row-count">{{getCountForType('Cancelled')}}</div>
  </div>
  <div class="block-item" (click)="filterByStatus('Declined')">
    <div class="block-row-title">{{'' | i18n: 'dash-header-declined'}}.</div>
    <div class="block-row-count">{{getCountForType('Declined')}}</div>
  </div>
  <div class="block-item" (click)="filterByStatus('Year To Date')">
    <div class="block-row-title">{{'' | i18n: 'dash-header-year-to-date'}}.</div>
    <div class="block-row-count">{{getCountForType('Year To Date')}}</div>
  </div>
</div>

<div class="filter-item-btn-creation" >
  <button [hidden]="!isAdmin()"id="addi"  routerLink="/upload" class="button button-defaul">{{'' | i18n: 'upload-warranty-contracts'}}
    <br/><span>{{'' | i18n: 'warranty contracts for all vehicles(bulk)'}}</span></button>
    @if (showExtendedWarranty) {
      <button id="adde" routerLink="/warranty/extended" class="button button-defaul">{{'' | i18n: 'dash-extended-warranty'}}
        <br/><span>{{'' | i18n: 'dash-extended-warranty-extra'}}</span></button>
      }
      <button id="add" routerLink="/warranty" class="button button-create">{{'' | i18n: 'dash-new-warranty'}}
        <br/><span>{{'' | i18n: 'dash-new-warranty-extra'}}</span></button>
      </div>
      <div class="row" style="margin-bottom: 15px;">
        <div class="filter-container">
          <div class="row">
            <div class="col-12">
              <div class="filter-item-blank">&nbsp;</div>
              @if (isAdmin() || isReadOnlyUser()) {
                <div class="filter-item-date" style="padding-left: 0.5%;">
                  <div class="filter-item-label">{{'' | i18n: 'user-dealer'}}:</div>
                  <select [(ngModel)]="getFilter().dealerName" (change)="getNinetyDaysPlusInProgressOrAllWarranties()">
                    <option value="null">{{'' | i18n: 'select'}}</option>
                    @for (dealer of dealerName; track dealer) {
                      <option value={{dealer}}>{{dealer}}</option>
                    }
                  </select>
                </div>
              }
              <div class="filter-item-date" style="padding-left: 0.5%;">
                <div class="filter-item-label">{{'' | i18n: 'status'}}:</div>
                <select [(ngModel)]="getFilter().status" (change)="inProgressFilterExecution()">
                  <option value="null">{{'' | i18n: 'select'}}</option>
                  <option value="Accepted">Accepted</option>
                  <option value="Active">Active</option>
                  <option value="In Progress" [selected]="showNinetyDaysPlusInProgressUI">In Progress</option>
                  <option value="In Dealer Correction">In Dealer Correction</option>
                  <option value="In Review">In Review</option>
                  <option value="Cancelled">Cancelled</option>
                  <option value="Declined">Declined</option>
                  <option value="Expired">Expired</option>
                  <option value="Year To Date">Year To Date</option>
                </select>
              </div>
              <div class="filter-item-date ml-2">
                <div class="filter-item-label">{{'' | i18n: 'contract-type'}}:</div>
                <select [(ngModel)]="getFilter().contractTypeId" (change)="getNinetyDaysPlusInProgressOrAllWarranties()">
                  <option value="null">{{'' | i18n: 'select'}}</option>
                  @for (c of contractTypes; track c) {
                    <option value="{{c.contractType}}">{{c.contractType}}</option>
                  }
                </select>
              </div>
              <div class="filter-item-date" style="padding-left: 0.5%;">
                <div class="filter-item-label">{{'' | i18n: 'contract-start'}}:</div>
                <input id="fromDate" type="date" name="fromDate" [(ngModel)]="getFilter().contractStartFrom"
                  (change)="getNinetyDaysPlusInProgressOrAllWarranties()">
                </div>
                <div class="filter-to">
                  {{'' | i18n: 'to'}}
                </div>
                <div class="filter-item-date" style="padding-left: 0.5%;">
                  <div class="filter-item-label" style="visibility: hidden;">..</div>
                  <input id="fromDates" type="date" name="fromDate" [(ngModel)]="getFilter().contractStartTo"
                    (change)="getNinetyDaysPlusInProgressOrAllWarranties()">
                  </div>
                </div>


                <div class=" col-12 pt-3">
                  <div class="filter-item-date" style="padding-left: 1.5%;">
                    <div class="filter-item-label">{{'' | i18n: 'contract-end'}}:</div>
                    <input id="toDate" type="date" name="toDate" [(ngModel)]="getFilter().contractEndFrom"
                      (change)="getNinetyDaysPlusInProgressOrAllWarranties()">
                    </div>
                    <div class="filter-to">
                      {{'' | i18n: 'to'}}
                    </div>
                    <div class="filter-item-date" style="padding-left: 0.5%;">
                      <div class="filter-item-label" style="visibility: hidden;">..</div>
                      <input id="toDates" type="date" name="toDate" [(ngModel)]="getFilter().contractEndTo"
                        (change)="getNinetyDaysPlusInProgressOrAllWarranties()">
                      </div>
                      <div class="filter-item-date" style="padding-left: 0.5%;">
                        <div class="filter-item-label">{{'' | i18n: 'brand'}}:</div>
                        <select [(ngModel)]="getFilter().brand" (change)="getNinetyDaysPlusInProgressOrAllWarranties()">
                          <option value="null">{{'' | i18n: 'select'}}</option>
                          <option value="BMW">BMW</option>
                          <option value="BMWi">BMWi</option>
                          <option value="MINI">MINI</option>
                          <option value="Motorrad">Motorrad</option>
                        </select>
                      </div>
                      <div class="filter-item-search" style="padding-left:.5%;">
                        <div class="filter-item-label">{{'' | i18n: 'dash-keyword'}}:</div>
                        <input id="keyword" type="text" name="keyword" [(ngModel)]="getFilter().keyword"
                          placeholder="{{'' | i18n: 'dash-keyword'}}"
                          (keydown.enter)="getNinetyDaysPlusInProgressOrAllWarranties()">
                        </div>
                        <div class="filter-item-search-btn" style="padding-top: 22px;">
                          <button id="refresh" (click)="getNinetyDaysPlusInProgressOrAllWarranties()" class="button search-btn ml-3">
                            <i class="fa fa-search" aria-hidden="true"></i>
                          </button>
                        </div>
                        <div class="filter-item-cross-btn" style="padding-top: 22px">
                          <button (click)="clearFilter()" class="button cross-btn ml-2">
                            <i class="fa fa-times" aria-hidden="true"></i>
                          </button>
                        </div>
                        <div class="filter-item-search-btn" style="padding-top: 22px; margin-left: 15px">
                          <button (click)="exportAsXLSX()" class="button search-btn ml-3">
                            <i class="fa fa-download" aria-hidden="true"></i>
                          </button>
                        </div>

                        <div class="pagecount-container" style="padding-top: 22px">
                          <button id="removePage" (click)="changePage(-1)" class="button button-page"
                            [disabled]="this.getFilter().page == 0"><img alt="" src="assets/images/BMW-previous-144.png" width="20px"
                          height="20px"></button>
                          <div class="page-text-container"> {{ getFilter().page + 1 }} </div>
                          <button id="addPage" (click)="changePage(1)" class="button button-page"
                            [disabled]="this.warrantyList.pageCount <= this.getFilter().page+1"><img alt=""
                            src="assets/images/BMW-next-144.png"
                            width="20px" height="20px">
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  @if (showNinetyDaysPlusInProgressUI) {
                    <div id='ninety-day-plus-instruction' class="col-12 ninety-day-plus-in-progress-msg">
                      {{sanitizeAndStyleData('' | i18n: 'ninety-day-plus-in-progress-instruction','ninety-day-plus-instruction')}}
                    </div>
                  }
                </div>

                <div class="form-row-container">
                  <div class="table-header">
                    <div class="table-header-item-status">
                      <a (click)="orderBy('status')">{{'' | i18n: 'status'}}@if (getFilter().orderBy == 'status') {
                        <img
                          src="{{showDirectionImage()}}" alt=""
                          class="sort-img"/>
                      }</a>
                    </div>
                    <div class="table-header-item-status">
                      <a (click)="orderBy('dateCreated')">{{'' | i18n: 'date-created'}}@if (getFilter().orderBy == 'dateCreated') {
                        <img
                          src="{{showDirectionImage()}}" alt="" class="sort-img"/>
                      }</a>
                    </div>
                    <div class="table-header-item-status-vin">
                      <a (click)="orderBy('vin')">{{'' | i18n: 'chassis'}}@if (getFilter().orderBy == 'vin') {
                        <img
                          src="{{showDirectionImage()}}" alt="" class="sort-img"/>
                      }</a>
                    </div>
                    <div class="table-header-item-status-license">
                      <a (click)="orderBy('licence')">{{'' | i18n: 'licence'}}@if (getFilter().orderBy == 'licence') {
                        <img
                          src="{{showDirectionImage()}}" alt=""
                          class="sort-img"/>
                      }</a>
                    </div>
                    <div class="table-header-item-status-license">
                      <a (click)="orderBy('brand')">{{'' | i18n: 'brand'}}@if (getFilter().orderBy == 'brand') {
                        <img
                          src="{{showDirectionImage()}}" alt="" class="sort-img"/>
                      }</a>
                    </div>
                    <div class="table-header-item-status-model">
                      <a (click)="orderBy('model')">{{'' | i18n: 'model'}}@if (getFilter().orderBy == 'model') {
                        <img
                          src="{{showDirectionImage()}}" alt="" class="sort-img"/>
                      }</a>
                    </div>
                    <div class="table-header-item-status-vin">
                      <a (click)="orderBy('contractType')">{{'' | i18n: 'warranty-type'}}@if (getFilter().orderBy == 'contractType') {
                        <img
                          src="{{showDirectionImage()}}" alt=""
                          class="sort-img"/>
                      }</a>
                    </div>
                    <div class="table-header-item-status">
                      <a (click)="orderBy('contractCode')">{{'' | i18n: 'contract-code'}}@if (getFilter().orderBy == 'contractCode') {
                        <img
                          src="{{showDirectionImage()}}" alt=""
                          class="sort-img"/>
                      }</a>
                    </div>
                    <div class="table-header-item-status">
                      <a (click)="orderBy('warrantyNumber')">{{'' | i18n: 'contract-number'}}@if (getFilter().orderBy == 'warrantyNumber') {
                        <img
                          src="{{showDirectionImage()}}" alt="" class="sort-img"/>
                      }</a>
                    </div>

                    <div class="table-header-item-status">
                      <a (click)="orderBy('contractStartDate')">{{'' | i18n: 'contract-start'}}@if (getFilter().orderBy == 'contractStartDate') {
                        <img
                          src="{{showDirectionImage()}}" alt="" class="sort-img"/>
                      }</a>
                    </div>
                    <div class="table-header-item-status">
                      <a (click)="orderBy('contractEndDate')">{{'' | i18n: 'contract-end'}}@if (getFilter().orderBy == 'contractEndDate') {
                        <img
                          src="{{showDirectionImage()}}" alt="" class="sort-img"/>
                      }</a>
                    </div>
                    <div class="table-header-item-status">
                      <a (click)="orderBy('contractMileage')">{{'' | i18n: 'mileage'}}@if (getFilter().orderBy == 'contractMileage') {
                        <img
                          src="{{showDirectionImage()}}" alt=""
                          class="sort-img"/>
                      }</a>
                    </div>
                    <div class="table-header-item-status">
                      <a>{{'' | i18n: 'owner'}}<img alt="" class="sort-img"/></a>
                    </div>
                    <div class="table-header-item-status">
                      <a (click)="orderBy('contractRate')">{{'' | i18n: 'premium'}}@if (getFilter().orderBy == 'contractRate') {
                        <img
                          src="{{showDirectionImage()}}" alt=""
                          class="sort-img"/>
                      }</a>
                    </div>
                    @if (showAttachments) {
                      <div class="table-header-item-status">
                        <a>{{'' | i18n: 'landing-attachment'}}<img alt="" class="sort-img"/></a>
                      </div>
                    }
                  </div>

                  @for (r of warrantyList.dataList; track r) {
                    <div class="table-list" routerLink="/warranty/{{r.id}}">
                      <div class="table-list-item-status">
                        <div class="{{getClass(r.status)}}">{{ r.status }}</div>
                      </div>
                      <div class="table-list-item-status">{{ r.dateCreated | customDate }}</div>
                      <div class="table-list-item-status-vin">{{ r.vin }}</div>
                      <div class="table-list-item-status-license">{{ r.licence }}</div>
                      <div class="table-list-item-status-license">{{ r.brand }}</div>
                      <div class="table-list-item-status-model">{{ r.model }}</div>
                      <div class="table-list-item-status-vin">{{ r.contractType }}</div>
                      <div class="table-list-item-status">{{ r.contractCode }}</div>
                      <div class="table-list-item-status">{{ r.warrantyNumber }}</div>
                      <div class="table-list-item-status">{{ r.contractStartDate | customDate }}</div>
                      <div class="table-list-item-status">{{ r.contractEndDate | customDate }}</div>
                      <div class="table-list-item-status">{{ r.contractMileage }}</div>
                      <div class="table-list-item-status-name">{{ r.firstName }} {{ r.middleName }} {{ r.lastName }}</div>
                      <div class="table-list-item-status">
                        {{amount(r)}}
                      </div>
                      @if (showAttachments && showFile(r)) {
                        <div class=" table-list-item-status language-icons">
                          <a class="table-list-item-status-file" (click)="printCertificateFR($event, r.warrantyNumber)">
                            <img alt="" src="assets/images/FR-icon.png">
                          </a>
                          <a class="table-list-item-status-file" (click)="printCertificateNL($event, r.warrantyNumber)">
                            <img alt="" src="assets/images/NL-icon.png">
                          </a>
                        </div>
                      }
                    </div>
                  }
                </div>
